import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Item from "./Item";
import QuickDetailItem from "./QuickDetailItem";
import {
  CART_ACCORDION_LABEL,
  QUICKDETAILS_ACCORDION_LABEL
} from "../../AppConstants";

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const CustomizedAccordions = ({leaseStatusViewData}) => {
  const [expanded, setExpanded] = React.useState('quickDetails');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion square expanded={expanded === 'cart'}
                 onChange={handleChange('cart')}>
        <AccordionSummary aria-controls="cartd-content"
                          id="cartd-header"
                          expandIcon={<ExpandMoreIcon/>}>
          <Typography>{CART_ACCORDION_LABEL}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography component={'div'}>
            <div className="fullCart">
            {
              leaseStatusViewData &&
              leaseStatusViewData.items?.map(
                (item) =>
                  <Item key={item.description} item={item}/>
              )
            }
            </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion square expanded={expanded === 'quickDetails'}
                 onChange={handleChange('quickDetails')}>
        <AccordionSummary aria-controls="quickDetailsd-content"
                          id="quickDetailsd-header"
                          expandIcon={<ExpandMoreIcon/>}>
          <Typography>{QUICKDETAILS_ACCORDION_LABEL}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography component={'div'}>
            {leaseStatusViewData && leaseStatusViewData.paymentScheduleInfo &&
            <QuickDetailItem
              paymentScheduleInfo={leaseStatusViewData.paymentScheduleInfo}/>}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default CustomizedAccordions;
